import type { ReactNode } from 'react'
import type { PlanPillTone } from '@/lib/planStatus'

const TONE_CLASSES: Record<PlanPillTone, string> = {
  primary: 'bg-[var(--fl-primary-faint)] text-[var(--fl-primary)]',
  warning: 'bg-[var(--fl-warning-bg)] text-[var(--fl-warning-text)]',
}

const SIZE_CLASSES = {
  sm: 'px-2 py-0.5 text-[11px]',
  md: 'px-2.5 py-1 text-xs',
} as const

export function PlanPill({
  tone,
  size = 'sm',
  children,
}: {
  tone: PlanPillTone
  size?: keyof typeof SIZE_CLASSES
  children: ReactNode
}) {
  return (
    <span
      className={`inline-block rounded-full font-medium ${TONE_CLASSES[tone]} ${SIZE_CLASSES[size]}`}
    >
      {children}
    </span>
  )
}
